export default "__VITE_ASSET__DHcDTxRR__"